import { NgModule } from '@angular/core';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { ZonelessEventsPlugin } from './zoneless.event-plugin';

@NgModule({
  providers: [
    { provide: EVENT_MANAGER_PLUGINS, multi: true, useClass: ZonelessEventsPlugin }
  ]
})
export class ZonelessEventModule { }
